import api from '../config/api';

const SUPPORTED_ADDRESS_COUNTRY_CODES = new Set([
  'IN', 'AE', 'DE',
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL',
  'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
]);

export const ADDRESS_COUNTRIES = [
  { code: 'IN', name: 'India' },
  { code: 'AE', name: 'United Arab Emirates' },
  { code: 'DE', name: 'Germany' },
  { code: 'AT', name: 'Austria' },
  { code: 'BE', name: 'Belgium' },
  { code: 'BG', name: 'Bulgaria' },
  { code: 'HR', name: 'Croatia' },
  { code: 'CY', name: 'Cyprus' },
  { code: 'CZ', name: 'Czech Republic' },
  { code: 'DK', name: 'Denmark' },
  { code: 'EE', name: 'Estonia' },
  { code: 'FI', name: 'Finland' },
  { code: 'FR', name: 'France' },
  { code: 'GR', name: 'Greece' },
  { code: 'HU', name: 'Hungary' },
  { code: 'IE', name: 'Ireland' },
  { code: 'IT', name: 'Italy' },
  { code: 'LV', name: 'Latvia' },
  { code: 'LT', name: 'Lithuania' },
  { code: 'LU', name: 'Luxembourg' },
  { code: 'MT', name: 'Malta' },
  { code: 'NL', name: 'Netherlands' },
  { code: 'PL', name: 'Poland' },
  { code: 'PT', name: 'Portugal' },
  { code: 'RO', name: 'Romania' },
  { code: 'SK', name: 'Slovakia' },
  { code: 'SI', name: 'Slovenia' },
  { code: 'ES', name: 'Spain' },
  { code: 'SE', name: 'Sweden' },
];

export const isSupportedAddressCountry = (code) =>
  SUPPORTED_ADDRESS_COUNTRY_CODES.has(String(code || '').toUpperCase());

const REGION_NAME_ALIASES = {
  bavaria: 'Bayern',
  bayern: 'Bayern',
  'free state of bavaria': 'Bayern',
  dubai: 'Dubai',
  'dubai emirate': 'Dubai',
  maharashtra: 'Maharashtra',
};

const normalizeRegionKey = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '');

/** Match geocoder state/emirate/Land to a region from the tax reference list */
export const matchRegionFromGeocoder = (countryCode, geocoderValue, regions = []) => {
  if (!geocoderValue || !regions?.length) return null;

  const raw = String(geocoderValue).trim();
  const normalizedInput = normalizeRegionKey(raw);
  const aliasTarget = REGION_NAME_ALIASES[normalizedInput];
  const searchKeys = aliasTarget
    ? [normalizedInput, normalizeRegionKey(aliasTarget)]
    : [normalizedInput];

  for (const region of regions) {
    if (
      normalizeRegionKey(region.code) === normalizedInput ||
      String(region.code).toUpperCase() === raw.toUpperCase()
    ) {
      return { code: region.code, name: region.name };
    }
  }

  for (const region of regions) {
    const regionKey = normalizeRegionKey(region.name);
    if (searchKeys.some((k) => k === regionKey || regionKey.includes(k) || k.includes(regionKey))) {
      return { code: region.code, name: region.name };
    }
  }

  return null;
};

export const getPostalCodeLabel = (countryCode) =>
  String(countryCode || '').toUpperCase() === 'IN' ? 'PIN code' : 'Postal code';

export const fetchRegionsByCountry = async (countryCode) => {
  const code = String(countryCode || '').toUpperCase();
  const res = await api.get(`/settings/regions/${code}`);
  return res.data?.regions || [];
};
